import { render, staticRenderFns } from "./tableContact.vue?vue&type=template&id=9332e972&"
import script from "./tableContact.js?vue&type=script&lang=js&"
export * from "./tableContact.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports